import { useQuery, useMutation, useQueryClient } from 'react-query';

import { api, get } from '../../lib/api';
import useForm from '../../lib/hooks/useForm';

const updateManageAccessSettings = ({ allUsersCanSuggest, allowedUsersId }) => {
  return api.put('/api/client_admin/suggestions_access', {
    everyone_can_make_tile_suggestions: allUsersCanSuggest,
    allowed_users: allowedUsersId,
  });
};

export const useManageAccessForm = ({ onClose }) => {
  const queryClient = useQueryClient();
  const {
    data = { everyone_can_make_tile_suggestions: false, allowed_users: [] },
  } = useQuery('getManageAccessSettings', () =>
    get('/api/client_admin/suggestions_access'),
  );

  const { mutate } = useMutation(updateManageAccessSettings, {
    onSuccess: ({ data: responseData }) => {
      queryClient.setQueryData('getManageAccessSettings', responseData);
      onClose();
    },
  });

  const initialValues = {
    allUsersCanSuggest: data.everyone_can_make_tile_suggestions || false,
    allowedUsers: data.allowed_users || [],
  };

  const onSubmit = ({ allUsersCanSuggest, allowedUsers }) => {
    const allowedUsersId = allowedUsers.map(user => user.id);

    mutate({ allUsersCanSuggest, allowedUsersId });
  };

  const form = useForm({
    onSubmit,
    enableReinitialize: true,
    initialValues,
  });

  const setAllowedUsers = ({ name, id }) => {
    const userNotSelected = !form.values.allowedUsers.some(
      user => user.id === id,
    );
    if (userNotSelected) {
      const newAllowedUsers = [...form.values.allowedUsers, { name, id }];
      form.setFieldValue('allowedUsers', newAllowedUsers);
    }
  };

  const removeAllowedUser = id => {
    const filteredUsers = form.values.allowedUsers.filter(
      user => user.id !== id,
    );
    form.setFieldValue('allowedUsers', filteredUsers);
  };

  return { ...form, setAllowedUsers, removeAllowedUser };
};
